

export class ParametreCollaborateurModel {
    param1 : number = 2;
}
